import React, { useMemo } from 'react'
import Link from 'next/link'
import { format } from 'date-fns'
import { Loader } from 'semantic-ui-react'
import JoinInButton from '@web/containers/Appointments/components/UpcomingCard/JoinInButton'
import {
  findMatchingProvider,
  isSameDay
} from '@web/containers/Appointments/components/UpcomingCard'

import { convertToTargetTimeZone } from '@web/helpers/getTimeZone'

import { mergeStyles } from '@enlyt/helpers/mergeStyles'
import { getDateLocale, activeLanguage } from 'providers/Localization/i18n'
import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'
import _ from 'lodash'
import localization from 'components/Tiles/UpcomingVisitsWidget/localization'
import withLocalization from '@web/helpers/localizationUtils'
import { useSelector } from 'react-redux'
import { getExternalLinks, getZoomLinks } from '@web/stores/Links/Select'
import { getIsCheckinFetched } from '@web/stores/Appointments/Select'

const DateCard = props => {
  const { t } = props
  const { theme } = useTheme()
  const defaultStyles = themeStyles(theme)
  const styles = mergeStyles(defaultStyles, props.style)

  const workflowStatus = _.get(props.workflow, 'workflowStatus')
  const isNotStartedCheckin = workflowStatus === 'NotStarted'
  const isStartedCheckin = workflowStatus === 'Started'
  const isCompletedCheckin = workflowStatus === 'Completed'
  let checkinMark
  if (isNotStartedCheckin) {
    checkinMark = 'checkin'
  } else if (isStartedCheckin) {
    checkinMark = 'checkin'
  } else if (isCompletedCheckin) {
    checkinMark = 'completedCheckin'
  }

  const isCheckinFetched = useSelector(getIsCheckinFetched)
  const isTelehealth = _.includes(
    _.toLower(props?.appointmentType || ''),
    'telehealth'
  )
  const zoomLinks = useSelector(getZoomLinks)
  const matchingProvider = findMatchingProvider(
    zoomLinks,
    _.get(props, 'providerName', '')
  )

  const href = props.linkTo + '?appointmentId=' + props.appointmentId
  const dateTimeObject = new Date(`${props.date} ${props.time}`)
  const result = convertToTargetTimeZone(dateTimeObject, props.timeZone)
  const month = result.error
    ? '-'
    : format(result.targetDate, 'MMM', {
        locale: getDateLocale(activeLanguage())
      })
  const day = result.error ? '-' : format(result.targetDate, 'dd')
  const time = result.error
    ? result.error
    : `${format(result.targetDate, 'h:mm aaa')} ${result.timeZoneAbbreviation}`

  const otherContent = _.get(useSelector(getExternalLinks), 'OtherContent', {})
  const timeInSF = _.get(otherContent, 'UFD_A_Temporarily_Used_Time', '')
  const appointmentDateTime = result.error ? '-' : result.targetDate
  const testUsingTime = timeInSF ? new Date(timeInSF) : ''
  const todayObject = new Date()

  const { loadingCheckin, currCheckinAppointmentId, appointmentId } = props
  const needShowZoomLink = useMemo(
    () => {
      return (
        isTelehealth &&
        matchingProvider &&
        isSameDay(appointmentDateTime, testUsingTime || todayObject) &&
        (!checkinMark || checkinMark === 'completedCheckin') &&
        isCheckinFetched
      )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return (
    <div style={styles.container} tabIndex={-1}>
      <Link href={href} style={styles.clickableContainer}>
        <div style={styles.month}>{month}</div>
        <div style={styles.day}>{day}</div>
        <div style={styles.time}>{time}</div>
        <div style={styles.title}>{props.appointmentType || ''}</div>
        {loadingCheckin && currCheckinAppointmentId === appointmentId ? (
          <div style={styles.checkinArea}>
            <Loader active inline />
          </div>
        ) : (
          checkinMark &&
          !needShowZoomLink && (
            <div style={styles.checkinArea}>
              <span style={styles[checkinMark]}>{t(`${checkinMark}`)}</span>
            </div>
          )
        )}
      </Link>
      {needShowZoomLink && (
        <div style={styles.joinInText}>
          <JoinInButton zoomLink={_.get(matchingProvider, 'ZoomLink', '')} />
        </div>
      )}
    </div>
  )
}

export default withLocalization(DateCard, localization)
